import { defineStore } from "pinia";
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

export const useLanguageStore = defineStore("language", () => {
  const { locale } = useI18n();
  const isArabic = ref(locale.value === "ar");
  const languageChanged = ref(false);
  const currentLanguage = ref(locale.value);

  // Watch for language changes
  watch(
    locale,
    (newLocale) => {
      isArabic.value = newLocale === "ar";
      currentLanguage.value = newLocale;
      languageChanged.value = true;

      // Reset the flag after a short delay
      setTimeout(() => {
        languageChanged.value = false;
      }, 100);
    },
    { immediate: true },
  );

  return {
    isArabic,
    languageChanged,
    currentLanguage,
    currentLocale: locale,
  };
});
